import {CompetitorArticlesFormField} from "../types/competitor-articles-form-field.types";
import {Validators} from "@angular/forms";

export const competitorArticlesFormFields: Array<CompetitorArticlesFormField> = [
  {
    fieldName: 'url',
    label: 'URL на страницу товара',
    type: 'text',
    validators: [ Validators.required ],
    visible: true
  },
  {
    fieldName: 'article',
    label: 'Артикул',
    visible: false,
    type: 'text',
    disabled: true
  },
  {
    fieldName: 'productTitle',
    label: 'Заголовок продукта на маркетплейсе',
    type: 'text',
    visible: true
  },
  {
    fieldName: 'articleName',
    label: 'Пользовательское название артикула',
    type: 'text',
    visible: true
  },
  {
    fieldName: 'productGroupId',
    label: 'id категории продуктов',
    type: 'select',
    visible: true
  },
  {
    fieldName: 'rating',
    label: 'Рейтинг товара',
    type: 'number',
    visible: true,
    decimals: 4
  },
  {
    fieldName: 'reviewsCount',
    label: 'Количество отзывов',
    type: 'number',
    visible: true
  }
]
